module.exports = __webpack_public_path__ + "img/banner_Backpack.fee777e9.png";